import React, { useState } from "react";
import { LANGUAGE } from '../../utils/languageProperties';

const ReadMoreText = ({ text, maxLength = 180 }: { text: string; maxLength?: number }) => {
  const [isExpanded, setIsExpanded] = useState(false);

  // If text is short, no need for Read More
  if (text.length <= maxLength) {
    return <p>{text}</p>;
  }

  const displayText = isExpanded ? text : text.slice(0, maxLength) + "...";

  return (
      <p>
          {displayText}
          <span
              onClick={() => setIsExpanded(!isExpanded)}
              style={{
                  color: '#003764',
                  cursor: 'pointer',
                  marginLeft: '5px',
                  fontWeight: 700
              }}
          >
              {isExpanded ? LANGUAGE['read-less'] : LANGUAGE['read-more']}
          </span>
      </p>
  );
};

export default ReadMoreText;